import React, { createContext, useContext, useState } from 'react';
import { useEffect } from 'react';
import { useToastContext } from 'context/ToastContext';
import { useLocale } from 'hooks/useLocale';
import { downloadExportCSV } from 'utils/CsvHelper';
import { SocketChannels, SocketListener } from 'utils/socket';
const initialState = {
    isDownloadInProcess: false,
    activeQueue: 0,
    data: {}
};
const defaultUpdate = () => initialState;
const DownloaderContext = createContext({
    state: initialState,
    setState: defaultUpdate
});
// PROVIDER
const DownloaderProvider = (props) => {
    const [state, setState] = useState(initialState);
    return React.createElement(DownloaderContext.Provider, { value: { state, setState }, ...props });
};
// MUTATION
const useDownloader = () => {
    const { state, setState } = useContext(DownloaderContext);
    const { addToast } = useToastContext();
    const { setBothLocale } = useLocale();
    const setIsDownloadInProcess = (inProcess) => {
        setState((draft) => ({ ...draft, isDownloadInProcess: inProcess }));
    };
    const setData = (data) => {
        setState((draft) => ({ ...draft, data }));
    };
    const setActiveQueue = (type) => {
        setState((draft) => ({
            ...draft,
            activeQueue: type == 'increment' ? draft.activeQueue + 1 : draft.activeQueue - 1
        }));
    };
    const listener = React.useMemo(() => new SocketListener(), []);
    const setupSocket = (openNewWindow, callbackConnected, showModal, successCallback
    // eslint-disable-next-line max-params, sonarjs/cognitive-complexity
    ) => {
        listener.register({
            name: SocketChannels.backgroundJobProgress(),
            callback: (data) => {
                setData(data);
                const element = document.getElementById('export-csv-user');
                if (!openNewWindow && !element) {
                    addToast({
                        id: 'export-csv-user',
                        title: setBothLocale('Preparing file completed!'),
                        msg: setBothLocale('CSV has been prepared and the file will be downloaded automatically'),
                        type: 'success'
                    });
                }
                if (data?.object?.file &&
                    (data?.object?.state == 'done' || data?.state == 'done')) {
                    if (openNewWindow) {
                        showModal && showModal();
                        const newWindow = window.open(data?.object?.file, '_blank', 'noopener,noreferrer');
                        if (newWindow)
                            newWindow.opener = null;
                    }
                    else {
                        downloadExportCSV(data?.object?.file);
                    }
                    setIsDownloadInProcess(false);
                    setActiveQueue('decrement');
                    listener.unregister();
                    successCallback && successCallback();
                }
            },
            callbackConnected: async () => {
                callbackConnected &&
                    setTimeout(async () => {
                        await callbackConnected();
                    }, 1000);
            }
        });
    };
    useEffect(() => {
        if (state.activeQueue == 0) {
            listener.unregister();
        }
    }, [state.activeQueue, listener]);
    return {
        data: state?.data,
        isDownloadInProcess: state?.isDownloadInProcess,
        setIsDownloadInProcess,
        setupSocket,
        setActiveQueue
    };
};
export { DownloaderProvider, useDownloader };
